/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Viewer_TitleInputs */

const vi_einvoice_viewer_title = /** @type {(inputs: Einvoice_Viewer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hóa đơn điện tử`)
};

/**

* @param {Einvoice_Viewer_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_viewer_title = /** @type {((inputs?: Einvoice_Viewer_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Viewer_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_viewer_title(inputs)
});